import { HOST } from "../constants/HostConstants";

export const advertisementAdminDelete = async (advertisement_id, reason) => {
  try {
    const response = await fetch(`${HOST}/api/advertisement/adminDelete`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ advertisement_id, reason }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to delete advertisement");
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting ad:", error);
    throw error;
  }
};
